<script lang="ts">
  import type { TransactionPanelProps } from "./types";
  import { createOrderDetailsQuery } from "../../../queries/order";

  import SectionHeader from "./SectionHeader.svelte";
  import OrderProductsTable from "./OrderProductsTable.svelte";
  import BaseTransactionPanel from "./BaseTransactionPanel.svelte";
  import OrderProductsSkeleton from "../../skeletons/OrderProductsSkeleton.svelte";
  import NotesView from "./NotesView.svelte";

  export let props: TransactionPanelProps;

  $: orderQuery = createOrderDetailsQuery(props.transaction.reference);
  $: notes = props.transaction.notes;
</script>

<BaseTransactionPanel {...props}>
  <div slot="top">
    {#if notes}
      <NotesView title={notes} />
    {/if}
  </div>
  <div class="order-products" slot="footer">
    <SectionHeader title="products" />

    {#if $orderQuery.isLoading}
      <div class="skeleton">
        <OrderProductsSkeleton />
      </div>
    {:else}
      <OrderProductsTable items={$orderQuery.data?.items} />
    {/if}
  </div>
</BaseTransactionPanel>

<style>
  .order-products {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
</style>
